<template>
  <v-card
    v-resize="resizeScreen"
    id="scroll-target"
    class="hide-overflow"
    v-if="product"
  >
    <div v-if="loadingProduct">
      <sync-loader
        :loading="loadingProduct"
        :key="theme.color"
        :color="theme.color"
        :size="'10px'"
        style="
          position: absolute;
          top: 50%;
          margin-top: -10px;
          left: 50%;
          margin-left: -21px;
        "
      ></sync-loader>
    </div>
    <div
      id="stickyHeader"
      class="white"
      :class="{ sticky: sticky }"
      v-scroll="checkStickyHeader"
    >
      <v-toolbar color="transparent" flat absolute style="z-index: 6">
        <v-btn color="grey lighten-2" icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn round color="grey lighten-2" depressed @click="openCheckout">
          <v-badge color="red">
            <template v-slot:badge v-if="totalItem > 0">
              <span>{{ totalItem }}</span>
            </template>
            <v-icon small class="mr-2">mdi-cart-outline</v-icon>
            <span>{{ $t('Checkout') }}</span>
          </v-badge>
        </v-btn>
      </v-toolbar>

      <v-container class="py-0" v-if="!loadingProduct">
        <div class="container_producttocart" v-if="showAddToCart">
          <div class="producttocart">
            <v-img
              v-if="productImages && productImages.length > 0"
              :src="productImages[0]"
              aspect-ratio="1"
              class="grey lighten-2"
              style="max-width: 180px; margin: auto"
            >
            </v-img>
          </div>
        </div>
        <v-layout wrap>
          <v-flex xs12>
            <div class="ma-auto">
              <hooper
                ref="productcarousel"
                :style="{ height: (sticky ? 130 : 150) + 'px' }"
                @slide="changeSlide"
              >
                <template v-if="productImages && productImages.length">
                  <slide
                    v-for="(image, img_index) in productImages"
                    :key="'image_' + img_index"
                    style="text-align: center"
                  >
                    <div
                      style="position: relative"
                      @click="showPreviewImage(image)"
                    >
                      <img
                        :src="image"
                        :style="{ 'max-height': sticky ? '130px' : '150px' }"
                        style="height: 100%; margin: auto"
                      />
                      <div
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          margin-left: -28px;
                          margin-top: -28px;
                        "
                      >
                        <v-btn
                          class="ma-0"
                          depressed
                          fab
                          dark
                          color="rgb(0, 0, 0, 0.2)"
                        >
                          <v-icon>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </slide>
                </template>
                <template v-else>
                  <slide style="text-align: center">
                    <div style="position: relative">
                      <img
                        src="@/assets/img/products/default-photo.png"
                        :style="{ 'max-height': sticky ? '130px' : '150px' }"
                        style="height: 100%; margin: auto"
                      />
                      <div
                        style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          margin-left: -28px;
                          margin-top: -28px;
                        "
                      >
                        <v-btn
                          class="ma-0"
                          depressed
                          fab
                          dark
                          color="rgb(0, 0, 0, 0.2)"
                        >
                          <v-icon>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </slide>
                </template>
                <navigation slot="hooper-addons"></navigation>
              </hooper>
            </div>

            <!-- Show Preview Image -->
            <v-dialog scrollable v-model="showPreview" max-width="690">
              <v-card v-if="currentPreview">
                <v-card-actions class="text-xs-right">
                  <v-layout>
                    <v-flex>
                      <v-btn flat fab icon small @click="showPreview = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
                <v-card-text class="pa-0 text-xs-center">
                  <v-zoom
                    :img="currentPreview"
                    :width="'100%'"
                    style="margin: auto"
                  ></v-zoom>
                </v-card-text>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-dialog>
            <!-- End Show Preview Image -->

            <div class="mb-2"></div>
          </v-flex>
          <v-flex xs12>
            <div class="subheading mb-1">{{ product.product_title }}</div>

            <div class>
              <template v-if="productstock > 0">
                <span
                  class="discount pr-2"
                  v-if="product.product_price != product.product_sale_net"
                >
                  {{ currencySign }}{{ product.product_price | decimalFormat }}
                </span>
                <span class="title price" :style="{ color: theme.color }">
                  <template>
                    {{ currencySign
                    }}{{ product.product_sale_net | decimalFormat }}</template
                  >
                </span>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <template v-if="hasScroll">
        <v-tabs
          height="33"
          v-model="tab"
          :slider-color="theme.color"
          grow
          @change="changeTab"
        >
          <v-tab :key="'options'" ripple>
            {{ $t('Options') }}
          </v-tab>
          <v-tab :key="'description'" ripplche>
            {{ $t('Product Detail') }}
          </v-tab>
        </v-tabs>
        <v-divider />
      </template>
    </div>
    <!-- Product Content -->
    <v-container>
      <v-layout
        v-if="!loadingProduct"
        id="options"
        wrap
        :style="{ 'padding-top': (sticky ? stickyHeight : 0) + 'px' }"
      >
        <v-flex xs12>
          <template
            v-if="
              product.product_attribute && product.product_attribute.length > 0
            "
          >
            <product-option
              v-if="!loadingProduct"
              v-model="currentOption"
              :category="isThailandPostmartOptions"
              @changeOption="onChangeOption"
              @focusOption="focusOption"
              @blurOption="onViewStockPhoto(null)"
            ></product-option>
          </template>
        </v-flex>
      </v-layout>
      <template
        v-if="
          $store.state.allowProductRemark.includes(pageProfile.pageid) &&
          !loadingProduct
        "
      >
        <v-text-field
          v-model="cart_remark"
          :color="theme.color"
          outline
          maxlength="50"
          counter="50"
          :data-vv-as="$t('Remark')"
          :name="'remark'"
          :label="$t('Remark')"
          :error="errors.has('remark') ? true : false"
          :error-messages="errors.has('remark') ? errors.first('remark') : ''"
        ></v-text-field>
      </template>

      <!-- Product Detail -->
      <v-layout wrap id="description" && !loadingProduct>
        <v-flex xs12>
          <v-divider class="mt-2 mb-3"></v-divider>
        </v-flex>
        <v-flex xs12>
          <div class="body-1">
            <h3 class="headline name mb-2" :style="{ color: theme.color }">
              {{ $t('Product Detail') }}
            </h3>
            <template v-if="product.description">
              <span v-html="product.description"></span>
              <!-- <nl2br
                tag="div"
                :text="product.description"
                class="description"
              ></nl2br> -->
            </template>
          </div>
        </v-flex>
      </v-layout>
      <!-- End of Product Detail -->

      <div style="height: 185px"></div>
      <v-card
        style="position: fixed; z-index: 3; bottom: 0; left: 0; right: 0"
        v-if="pageProfile && pageProfile.type != 'ros'"
      >
        <v-divider />
        <v-layout>
          <!-- Construction Page Customize -->
          <template
            v-if="
              pageProfile &&
              ((productstockcategories && productstockcategories.length == 0) ||
                currentOption)
            "
          >
            <v-flex class="pl-3 pr-1 py-1">
              <!-- Show Price -->
              <v-layout>
                <v-flex shrink style="white-space: nowrap">
                  <div style="display: flex; height: 100%; align-items: center">
                    <div>{{ $t('Total') }}</div>
                  </div>
                </v-flex>
                <v-flex
                  class="text-xs-right"
                  style="font-weight: 600; font-size: 20px"
                >
                  <template v-if="productstock > 0">
                    <!-- <span
                        class="discount mr-1"
                        v-if="
                          option != null &&
                            option[3] !=
                              calculateBundlePrice(
                                option[3],
                                totalBundle + quantity,
                                isWholesale ? wholesale : productbundle
                              )
                        "
                        >{{ currencySign
                        }}{{
                          (option[3] * quantity + additional_price)
                            | decimalFormat
                        }}</span
                      > -->
                    {{ currencySign
                    }}{{
                      (isThailandPostmartProductPrice * quantity)
                        | decimalFormat
                    }}
                  </template>
                </v-flex>
              </v-layout>
              <!-- End of Show Price -->

              <!-- Weight -->
              <template>
                <div class="caption grey--text">
                  {{
                    $t('Weight {weight} kilogram per piece', {
                      weight: '-'
                    })
                  }}
                  <!-- weight: option[8] / 1000 -->
                </div>
              </template>

              <div v-if="productstock == 0" class="red--text">
                {{ $t('Sold Out') }}
              </div>
            </v-flex>

            <v-flex shrink class="text-xs-right" style="white-space: nowrap">
              <template v-if="productstock > 0">
                <v-btn
                  outline
                  fab
                  :color="theme.color"
                  @click="removeCount()"
                  :disabled="quantity == 1"
                  style="height: 30px; width: 30px"
                  small
                >
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>

                <!-- Choose quantity -->
                <span
                  class="text-center"
                  style="
                    width: 60px;
                    display: inline-block;
                    margin-left: 5px;
                    margin-right: 5px;
                    text-align: center;
                  "
                >
                  <v-text-field
                    class="quantity text-center mt-2"
                    outline
                    box
                    dense
                    type="number"
                    single-line
                    hide-details
                    :height="40"
                    v-model="quantity"
                    :color="theme.color"
                    @blur="changeQuantity"
                    @change="changeQuantity"
                  ></v-text-field
                ></span>
                <!-- End of Choose quantity -->

                <v-btn
                  outline
                  fab
                  :color="theme.color"
                  @click="addCount"
                  style="height: 30px; width: 30px"
                  small
                >
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-flex>
          </template>
        </v-layout>

        <!-- Action Footer -->
        <v-layout>
          <v-flex xs12>
            <v-divider />

            <template v-if="!isOutOfStock">
              <template>
                <v-layout wrap>
                  <v-flex xs5>
                    <v-btn
                      depressed
                      flat
                      large
                      :loading="loading || loadingCart || loadingProduct"
                      :color="theme.color"
                      @click="addToCart('addtocart')"
                      :class="{
                        disabled: isOutOfStock || isNotSelectedOptions
                      }"
                      :disabled="isOutOfStock || isNotSelectedOptions"
                      style="width: 100%; border-radius: 0; height: 55px"
                      class="ma-0"
                      :style="{
                        'padding-bottom': $store.getters.getIosPadding
                          ? '15px'
                          : '0'
                      }"
                    >
                      <v-icon>mdi-cart-plus</v-icon>&nbsp;
                      <span>{{ $t('Add to cart') }}</span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs7>
                    <v-btn
                      depressed
                      large
                      :loading="loading || loadingCart || loadingProduct"
                      :color="theme.color"
                      @click="addToCart('addandclose')"
                      :class="{
                        disabled: isOutOfStock || isNotSelectedOptions,
                        'white--text': !isNotSelectedOptions
                      }"
                      :disabled="isOutOfStock || isNotSelectedOptions"
                      style="width: 100%; border-radius: 0; height: 55px"
                      class="ma-0"
                      :style="{
                        'padding-bottom': $store.getters.getIosPadding
                          ? '15px'
                          : '0'
                      }"
                    >
                      <v-icon>mdi-cart-outline</v-icon>&nbsp;

                      <span>{{ $t('Buy') }}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </template>
            </template>
            <template v-else>
              <v-btn
                color="grey"
                dark
                style="width: 100%; border-radius: 0; height: 55px"
                class="ma-0"
                readonly
              >
                {{ $t('Sold Out') }}
              </v-btn>
            </template>
          </v-flex>
        </v-layout>
        <!-- End of Action Footer -->
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import { Hooper, Slide, Pagination, Navigation } from 'hooper'
import 'hooper/dist/hooper.css'

import { mapGetters } from 'vuex'

import $ from 'jquery'
import config from '@/config'
import axios from 'axios'
import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import Modal from '@/components/Modal.vue'
import ModalImage from '@/components/ModalImage.vue'
import numeral from 'numeral'
import ProductOption from './ProductOption.vue'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import Nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
// import { Carousel, Slide } from "vue-carousel";

import vZoom from 'vue-zoom'
import { bearhousepackagehasbubble } from '@/assets/js/BearHouse.js'

export default {
  props: ['value', 'products', 'loadingCart', 'categories'],
  data() {
    return {
      tab: null,
      showAddToCart: false,
      snackbar: false,
      currentOption: null,
      product: this.value,
      showAlert: false,
      showPreview: false,
      optionkhaiwhan: '',
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: false,
      loading: false,
      productbundle: [],
      isImageFail: false,
      bubbletea: [],
      additional_price: 0,
      currentPhoto: null,
      gaigaoaddon: null,
      hasAddon: false,
      hasTopup: false,
      topups: [],
      remarkcount: 0,
      optionGaiGao: [],
      cart_remark: '',
      sticky: false,
      stickyHeight: 0,
      hasScroll: true,
      productLoading: true
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      theme: 'getTheme',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile'
    }),
    filterCategory() {
      if (!this.categories) {
        return []
      }
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        var categories = this.categories
          .filter((el) => {
            return el.name.includes(this.shop)
          })
          .map((el) => {
            var cat = { ...el }
            cat.name = cat.name.replace(this.shop + '/', '')
            return cat
          })
        return categories
      } else {
        return this.categories
      }
    },
    filterCart() {
      return this.cart
    },
    totalItem() {
      return this.filterCart.length > 0
        ? this.filterCart
            .map((el) => {
              return parseInt(el.quantity)
            })
            .reduce((prev, cur) => {
              return prev + cur
            })
        : 0
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == 'gaigao'
    },
    category() {
      return this.categories.find((el) => el.id == this.product.categoryid)
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    isNotSelectedOptions() {
      if (
        this.product.product_attribute &&
        this.product.product_attribute.length > 0 &&
        this.currentOption == null
      ) {
        return true
      } else {
        return false
      }
    },
    currencySign: function () {
      if (this.product && this.product.currency) {
        return this.getCurrencyByCode(this.product.currency)
      }
      return '฿'
    },
    productImages: function () {
      let images = []
      if (this.product) {
        if (typeof this.product.product_thumb == Array) {
          images = this.product.product_thumb
        } else {
          images.push(this.product.product_thumb)
        }
      }
      return images
    },
    isOutOfStock: function () {
      return false
    },
    priceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.price
        max = this.product.price
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][3]
            max = this.product.productstock[index][3]
          } else {
            if (this.product.productstock[index][3] > max) {
              max = this.product.productstock[index][3]
            }
            if (this.product.productstock[index][3] < min) {
              min = this.product.productstock[index][3]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.discountprice
        max = this.product.discountprice
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][4]
            max = this.product.productstock[index][4]
          } else {
            if (this.product.productstock[index][4] > max) {
              max = this.product.productstock[index][4]
            }
            if (this.product.productstock[index][4] < min) {
              min = this.product.productstock[index][4]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function () {
      var max = 0
      if (!this.product.productstock) {
        return 0
      }

      if (this.product.productstock.length <= 0) {
        max =
          ((this.product.price - this.product.discountprice) /
            this.product.price) *
          100
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            max =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
          } else {
            var percent =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
            if (max < percent) {
              max = percent
            }
          }
        }
      }

      return max
    },
    totalBundle: function () {
      var vm = this
      var quantity = 0
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function (product) {
            quantity += product.quantity
          })
        }
        return quantity
      }
      var products = vm.cart.filter(function (product) {
        return product.id == vm.product.id
      })
      quantity = 0
      products.map((p) => {
        quantity += p.quantity
      })
      return quantity
    },
    productstock() {
      return 99
      //return this.product.productstock;
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.id)
    },
    productstockcategories() {
      try {
        return JSON.parse(this.product.productstockcategories)
      } catch (error) {
        return []
      }
    },
    addonproducts() {
      if (!this.products) {
        return false
      }
      return this.products.filter((el) => {
        return el.categoryid == 10625
      })
    },
    isThailandPostmartProductPrice() {
      return this.product.product_sale_net
    },
    isThailandPostmartOptions() {
      let options = []
      options[0] = this.product.product_attribute
      options[1] = this.product.product_attribute_gift
      options[2] = this.product.product_attribute_gift_enforce
      return options
    }
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    // Carousel,
    Slide,
    Hooper,
    Pagination,
    Navigation,
    ProductOption,
    // Slide,
    SyncLoader
  },
  watch: {
    value: function () {
      let vm = this
      this.product = this.value
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0].image
      }

      vm.setOption()
    },
    showModal: function (newVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  },
  created: function () {},
  async mounted() {
    let vm = this
    await this.getProductDetailBySku(this.product.sku)
    vm.setOption()
    vm.loadingProduct = false
    this.$nextTick().then(() => {
      this.resizeScreen()
    })
  },
  methods: {
    async getProductDetailBySku(sku) {
      this.loadingProduct = true
      const pageid = config.thailandpostmart.pageid.pagename
      let response = await axios.get(
        config.thailandpostmart.serverUrl + `product/${sku}?pageid=${pageid}`,
        { headers: config.thailandpostmart.auth }
      )
      if (response.data.responsecode == 200) {
        this.loadingProduct = false
        this.product = response.data.data
        this.cart_remark = ''
        if (this.productImages.length > 0) {
          this.selectedImage = this.productImages[0].image
        }
        this.product.description = this.product.product_description || '-'
      }
    },
    changeSlide(slide) {
      if (slide && slide.currentSlide != null) {
        try {
          if (
            this.productImages[slide.currentSlide] &&
            this.productImages[slide.currentSlide].index &&
            this.productImages[slide.currentSlide].index.includes('stock_')
          ) {
            var currentstock =
              this.productImages[slide.currentSlide].index.split('_')

            var stock = this.productstock.find((el) => {
              // console.log(el[1]);
              return el[0] == currentstock[1]
            })

            this.onChangeOptionList(stock)
          } else {
            // this.onChangeOptionList(this.productstock[0]);
          }
        } catch (error) {
          // this.onChangeOptionList(this.productstock[0]);
        }
      }
    },
    resizeScreen() {
      try {
        this.hasScroll = window.innerHeight < document.body.offsetHeight
      } catch (error) {
        //
      }
    },
    changeTab(e) {
      try {
        if (e == 1) {
          this.$vuetify.goTo('#description', {
            duration: 300,
            offset: 0,
            easing: 'linear'
          })
        } else {
          this.$vuetify.goTo('#options', {
            duration: 300,
            offset: 0,
            easing: 'linear'
          })
        }
      } catch (error) {
        //
      }
    },
    checkStickyHeader(e) {
      // Get the header
      try {
        if (e.target.scrollingElement.scrollTop != 0) {
          this.sticky = true
        } else {
          this.sticky = false
        }

        var scrollPos = e.target.scrollingElement.scrollTop,
          lists = ['options', 'description']
        lists.forEach((el, index) => {
          var curr = document.getElementById(el)
          var h = document.body.offsetHeight
          if (h == scrollPos + window.innerHeight) {
            this.tab = lists.length - 1
          } else if (
            curr.offsetTop <= scrollPos &&
            curr.offsetTop + curr.clientHeight > scrollPos
          ) {
            this.tab = index
          } else {
            this.tab = 0
          }
        })

        this.stickyHeight = document.getElementById('stickyHeader').clientHeight
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    changeQuantity(event) {
      if (event.target) {
        let value = event.target.value
        try {
          if (value < 1) {
            this.quantity = 1
          } else {
            this.quantity =
              value > this.productstock ? this.productstock : value
          }
        } catch (error) {
          this.quantity = 1
        }
      }
    },
    openCheckout() {
      this.$emit('openCheckout')
    },
    focusOption(payload) {
      this.onViewStockPhoto(payload)
      this.option = payload
      this.quantity = 1
    },
    changeAddon(value) {
      this.gaigaoaddon = value
      this.updateTopupPrice()
    },
    onChangeOptionList(type) {
      var stock = type

      if (stock) {
        this.option = stock
        this.quantity = 1
      } else {
        this.option = null
        this.quantity = 1
      }
    },
    onChangeOption(val) {
      if (val) {
        this.product.selectedOption = {
          option1: val.option1,
          option2: val.option2,
          option3: val.option3
        }
        this.product.sku = this.product.sku
        this.product.product_price = val.product_price
        this.product.product_sale_net = val.product_sale_net
      }
    },
    async onViewStockPhoto(val) {
      await this.$nextTick()

      if (val) {
        var index = this.productImages.findIndex((el) => {
          return el.index == 'stock_' + val[0]
        })
        if (index != -1) this.$refs.productcarousel.slideTo(index)
        this.currentPhoto = val[7]
      }
      // this.$refs.carousel.slideTo(this.carouselData);
    },
    updateBubblePrice() {
      var price = 0

      if (this.bubbletea && this.bubbletea.length > 0) {
        this.bubbletea.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity
          } else {
            price += el.discountprice * el.quantity
          }
        })
      }
      this.additional_price = price
    },
    updateTopupPrice() {
      var price = 0

      if (this.topups && this.topups.length > 0) {
        this.topups.map((el) => {
          if (el.productstock.length > 0) {
            price += el.productstock[0][4] * el.quantity
          } else {
            price += el.discountprice * el.quantity
          }
        })
      }
      if (
        this.gaigaoaddon &&
        this.gaigaoaddon.productstock.length > 0 &&
        this.gaigaoaddon.productstock[0][2] > 0
      ) {
        price += this.gaigaoaddon.productstock[0][4]
      }
      this.additional_price = price
    },
    onPreviewImgError: function () {
      this.isImageFail = true
    },
    setOption: function () {
      let vm = this
      if (
        vm.product &&
        vm.product.productstock &&
        vm.product.productstock.length > 0
      ) {
        vm.option = null
        try {
          var option = vm.productstock.find((val) => {
            return val && parseInt(val[2]) > 0
          })

          if (option) {
            vm.option = option
            vm.currentOption = vm.option[1]
            return false
          }
        } catch (error) {
          //
        }
      } else {
        vm.option = null
      }
    },
    close: async function () {
      let isClose = true
      if (isClose) {
        this.closeWindow()
      }
    },
    closeWindow() {
      this.showModal = false
      this.$emit('close')

      if (window.history.length == 0) {
        //
      } else {
        window.history.back()
      }
    },
    addCount() {
      if (this.quantity < this.productstock) {
        this.quantity++
      }
    },
    removeCount() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    async addToCart(addcarttype) {
      let vm = this
      this.quantity = parseInt(this.quantity)
      var isClose = ['addandclose', 'addandcheckout'].includes(addcarttype)

      if (vm.isOutOfStock || vm.isNotSelectedOptions) {
        return false
      }
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      vm.loading = true

      let price = this.product.product_price
      // Assign this variable caz it's bundle price to calculate in summary checkout
      let discountprice = this.product.product_sale_net
      // console.log('selectedOption: ', vm.product.selectedOption)

      // console.log('vm.product.selectedOption: ', vm.product.selectedOption)

      let selectOptionTitle = ''

      if (vm.product.selectedOption) {
        if (
          vm.product.selectedOption.option1 &&
          vm.product.selectedOption.option1.product_title
        ) {
          selectOptionTitle = `${vm.product.selectedOption.option1.product_title}`
        }
        if (
          vm.product.selectedOption.option2 &&
          vm.product.selectedOption.option2.product_title
        ) {
          selectOptionTitle = selectOptionTitle.concat(
            ' ',
            `${vm.product.selectedOption.option2.product_title}`
          )
        }
        if (
          vm.product.selectedOption.option3 &&
          vm.product.selectedOption.option3.product_title
        ) {
          selectOptionTitle = selectOptionTitle.concat(
            ' ',
            `${vm.product.selectedOption.option3.product_title}`
          )
        }
      } else {
        selectOptionTitle = 'Normal'
      }

      let item = {
        quantity: parseInt(vm.quantity),
        currency: 'THB',
        categoryid: 0,
        description: vm.product.description,
        id: vm.product.sku,
        name: vm.product.product_title,
        pageid: vm.$store.state.pageProfile.pageid,
        photourl: vm.product.product_thumb,
        price: price,
        productStock: {
          id: vm.product.sku,
          type: selectOptionTitle,
          quantity: this.productstock
        },
        selectedOption: vm.product.selectedOption
          ? vm.product.selectedOption
          : null,
        discountprice: discountprice,
        weight: 0
      }

      vm.$emit('addToCart', {
        item: item,
        loading() {
          if (['addtocart'].includes(addcarttype)) {
            vm.showAddToCart = false
            vm.$nextTick().then(() => {
              vm.showAddToCart = true
            })
          }
          if (!vm.isCDS && vm.pageProfile.type != 'chillpainai') {
            if (isClose) {
              if (['addandcheckout'].includes(addcarttype)) {
                vm.$emit('openCheckout')
              } else {
                vm.closeWindow()
              }
            } else {
              // vm.snackbar = true;
            }
            vm.quantity = 1
          }
          vm.loading = false
        }
      })
    },
    showPreviewImage(image) {
      this.currentPreview = image
      this.showPreview = true
    }
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.checkStickyHeader(), false);
  }
}
</script>
<style lang="scss">
#construct_productoption {
  label {
    width: 100%;
  }
}
.full-width {
  .v-input__control {
    width: 100% !important;
  }
}

.container_producttocart {
  right: 0;
  position: fixed;
  z-index: 5;
  width: 200px;
  animation: drawArc1 2s linear 1;
}

.producttocart {
  border-radius: 10px;
  overflow: hidden;
  display: inline-block;
  border: 1px solid white;
  width: 50px;
  height: 50px;
  background: grey;
  opacity: 0;
  animation: drawArc2 2s linear 1;
}

@keyframes drawArc1 {
  0% {
    transform: translateY(100px);
  }
  10% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}

@keyframes drawArc2 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
    transform: rotate(360deg);
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(270deg);
  }
}

.quantity {
  &.v-input .v-input__slot {
    border-width: 1px;
    input[type='text'],
    input[type='number'] {
      text-align: center;
      margin: 0px;
    }
  }

  &.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

.radio-group-full-width {
  display: block !important;
}

.radio-group-full-width >>> .v-input__control {
  width: 100%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.container .v-chip .v-chip__content {
  cursor: pointer;
}
</style>
